import React, { useState } from 'react';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { ArrowBack, Inventory2Outlined, LockResetOutlined, MailOutline } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch } from '../services/api';

export default function ZapomnianeHaslo(){
  const navigate=useNavigate();
  const [email,setEmail]=useState('');
  const [blad,setBlad]=useState('');
  const [info,setInfo]=useState('');
  const [wysylanie,setWysylanie]=useState(false);

  const submit=async e=>{
    e.preventDefault();setBlad('');setInfo('');setWysylanie(true);
    try{
      const r=await apiFetch('/haslo/reset-request',{
        method:'POST',
        body:JSON.stringify({email})
      });
      setInfo(r.message);
    }catch(e){
      setBlad(e.message);
    }finally{
      setWysylanie(false);
    }
  };

  return (
    <Box sx={{minHeight:'100vh',bgcolor:'#f4f7fb',display:'grid',placeItems:'center',p:{xs:2,md:4}}}>
      <Paper elevation={0} sx={{
        width:'100%',maxWidth:980,minHeight:{md:560},display:'grid',
        gridTemplateColumns:{xs:'1fr',md:'0.92fr 1.08fr'},overflow:'hidden',borderRadius:4,
        border:'1px solid #e1e8f2',boxShadow:'0 18px 55px rgba(18,46,84,.10)'
      }}>
        <Box sx={{
          display:{xs:'none',md:'flex'},flexDirection:'column',justifyContent:'space-between',
          p:5,color:'#fff',
          background:'linear-gradient(145deg, #173d73 0%, #245fae 58%, #2f80ed 100%)'
        }}>
          <Box>
            <Box sx={{
              width:58,height:58,borderRadius:3,display:'grid',placeItems:'center',
              bgcolor:'rgba(255,255,255,.14)',border:'1px solid rgba(255,255,255,.22)',mb:3
            }}>
              <Inventory2Outlined sx={{fontSize:32}}/>
            </Box>
            <Typography variant="h4" fontWeight={900} sx={{lineHeight:1.15,mb:1.5}}>
              Ewidencja środków trwałych
            </Typography>
            <Typography sx={{color:'rgba(255,255,255,.78)',maxWidth:330,lineHeight:1.65}}>
              Odzyskaj dostęp do swojego konta.
            </Typography>
          </Box>
          <Typography variant="caption" sx={{color:'rgba(255,255,255,.60)'}}>
            System ewidencji środków trwałych
          </Typography>
        </Box>

        <Box sx={{
          p:{xs:3,sm:5,md:6},display:'flex',flexDirection:'column',justifyContent:'center',bgcolor:'#fff'
        }}>
          <Box sx={{display:{xs:'flex',md:'none'},alignItems:'center',gap:1.2,mb:4}}>
            <Box sx={{width:42,height:42,borderRadius:2.2,display:'grid',placeItems:'center',bgcolor:'#eaf2ff',color:'#2364d8'}}>
              <Inventory2Outlined/>
            </Box>
            <Typography fontWeight={900}>Ewidencja środków trwałych</Typography>
          </Box>

          <Box sx={{width:48,height:48,borderRadius:2.5,bgcolor:'#eaf2ff',color:'#2364d8',display:'grid',placeItems:'center',mb:2.5}}>
            <LockResetOutlined/>
          </Box>

          <Typography variant="h4" fontWeight={900} sx={{color:'#1c2b3a',mb:.7}}>
            Reset hasła
          </Typography>
          <Typography color="text.secondary" sx={{mb:3.5}}>
            Podaj adres e-mail przypisany do konta.
          </Typography>

          {blad&&<Alert severity="error" sx={{mb:2.5,borderRadius:2}}>{blad}</Alert>}
          {info&&<Alert severity="success" sx={{mb:2.5,borderRadius:2}}>{info}</Alert>}

          <Box component="form" onSubmit={submit}>
            <TextField
              fullWidth
              type="email"
              label="E-mail"
              value={email}
              onChange={e=>setEmail(e.target.value)}
              required
              sx={{mb:2.5}}
              InputProps={{
                startAdornment:<MailOutline sx={{color:'#7b8794',mr:1}}/>
              }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              disabled={wysylanie}
              sx={{
                minHeight:48,borderRadius:2,textTransform:'none',fontWeight:850,fontSize:15,
                boxShadow:'none',bgcolor:'#2364d8','&:hover':{bgcolor:'#1d56ba',boxShadow:'none'}
              }}
            >
              {wysylanie?'Wysyłanie...':'Wyślij kod'}
            </Button>
          </Box>

          {info&&(
            <Button
              fullWidth
              variant="outlined"
              onClick={()=>navigate('/reset-hasla',{state:{email}})}
              sx={{mt:2,minHeight:46,borderRadius:2,textTransform:'none',fontWeight:750}}
            >
              Mam kod — ustaw nowe hasło
            </Button>
          )}

          <Button
            component={Link}
            to="/logowanie"
            startIcon={<ArrowBack/>}
            sx={{mt:2.2,alignSelf:'flex-start',textTransform:'none',fontWeight:750}}
          >
            Wróć do logowania
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
